import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion, useScroll, useSpring } from "framer-motion";
import "@/App.css";
import { lenisStore, scrollToId } from "@/lib/scroll";
import { Nav } from "@/components/site/Nav";
import Home from "@/pages/Home";
import TopicsIndex from "@/pages/TopicsIndex";
import TopicPage from "@/pages/TopicPage";
import People from "@/pages/People";
import PeopleIndex from "@/pages/PeopleIndex";
import VidyaSri from "@/pages/VidyaSri";

const RouteScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash.slice(1)), 300);
      return () => clearTimeout(t);
    }
    scrollToId("top", true);
    return undefined;
  }, [pathname, hash]);
  return null;
};

function App() {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 25 });

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisStore.current = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenisStore.current = null; };
  }, []);

  return (
    <BrowserRouter>
      <div className="App bg-ink text-white min-h-screen grain">
        <motion.div style={{ scaleX: progress }} className="fixed top-0 left-0 right-0 h-[3px] bg-lime origin-left z-[60]" data-testid="scroll-progress" />
        <RouteScroll />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/topics" element={<TopicsIndex />} />
          <Route path="/people" element={<PeopleIndex />} />
          <Route path="/people/apoorva-chandra" element={<People />} />
          <Route path="/people/vidya-sri" element={<VidyaSri />} />
          <Route path="/:slug" element={<TopicPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
